const state = {
  signType: JSON.parse(sessionStorage.getItem('signType')) || null,
  signTransactionID:
    JSON.parse(sessionStorage.getItem('signTransactionID')) || null,
  signBusena: JSON.parse(sessionStorage.getItem('signBusena')) || null,
}
const getters = {
  signType: state => state.signType,
  signTransactionID: state => state.signTransactionID,
  signBusena: state => state.signBusena,
}
const actions = {
  signType({ commit, dispatch }, signType) {
    commit('SET_SIGN_TYPE', signType)
    state.signType = signType
  },
  signTransactionID({ commit, dispatch }, signTransactionID) {
    commit('SET_SIGN_TRANSACTION_ID', signTransactionID)
    state.signTransactionID = signTransactionID
  },
  signBusena({ commit, dispatch }, signBusena) {
    commit('SET_SIGN_BUSENA', signBusena)
    state.signBusena = signBusena
  },
}
const mutations = {
  SET_SIGN_TYPE(state, data) {
    state.signType = data
    sessionStorage.setItem('signType', JSON.stringify(data))
  },
  SET_SIGN_TRANSACTION_ID(state, data) {
    state.signTransactionID = data
    sessionStorage.setItem('signTransactionID', JSON.stringify(data))
  },
  SET_SIGN_BUSENA(state, data) {
    state.signBusena = data
    sessionStorage.setItem('signBusena', JSON.stringify(data))
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
